var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/CirclePattern/CirclePattern.js",
    _this = this;

import React from 'react';
import { WrapperVariant1, WrapperVariant2, ThumbnailVariant1, ThumbnailVariant2, Image, ContentVariant1, ContentVariant2, Title, getBodyVariant1, BodyVariant2 } from './style';
import useDevice from '../../core/hooks/useDevice';

var CirclePattern = function CirclePattern(_ref) {
  var type = _ref.type,
      thumbnail = _ref.thumbnail,
      title = _ref.title,
      flush = _ref.flush,
      body = _ref.body;

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var BodyVariant1 = getBodyVariant1(isMobile);
  return type === 'variant1' ? /*#__PURE__*/React.createElement(WrapperVariant1, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ThumbnailVariant1, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: thumbnail.url,
    alt: thumbnail.alt,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ContentVariant1, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(BodyVariant1, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }, body))) : /*#__PURE__*/React.createElement(WrapperVariant2, {
    flush: flush,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ThumbnailVariant2, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: thumbnail.url,
    alt: thumbnail.alt,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ContentVariant2, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, title), /*#__PURE__*/React.createElement(BodyVariant2, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, body)));
};

CirclePattern.defaultProps = {
  type: 'variant1'
};
export default CirclePattern;